import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS} from "@/lib/auth/roles";
import BulkInviteEdit from "@/modules/bulk-invite/edit";
import {BULK_INVITE_CREATE_URL, BULK_INVITE_EDIT_PATH} from "@/utils/urls";

export const Route = createFileRoute(BULK_INVITE_EDIT_PATH)({
  component: RouteComponent,
  loader: async ({params}) => {
    const {id} = params
    return {id}
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Invite feedback', path: '#'},
        {label: 'Send invites', path: BULK_INVITE_CREATE_URL},
      ],
      children: <div className={'h-10'}></div>,
      canSwitchFirm: false
    }
  }
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation
        roles={[]}
        permissions={[PERMISSIONS.IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK]}
        forbiddenFallback={<Unauthorized/>}>
        <BulkInviteEdit/>
      </Authorisation>
    </div>
  )
}
